/* @indexer:no-export */
import noop from '../utils/noop';
import modifyClassnames from '../utils/modifyClassnames';
function getClassNames(classNames) {
  return function (state) {
    var rowInfo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var column = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var instance = arguments.length > 3 ? arguments[3] : undefined;
    return {
      className: modifyClassnames(classNames, state.nameSpace, column.id)
    };
  };
}

/**
 * @param {String} classNames space-separated string of classes
 * @param {Function} getter function that returns an object with additional properties
 * @returns {Object}
 */
export function getAdditionalProps(classNames) {
  var getter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
  var getAdditionalClassNames = getClassNames(classNames);
  return function () {
    return Object.assign({}, getAdditionalClassNames.apply(void 0, arguments), getter.apply(void 0, arguments));
  };
}